import React, { FunctionComponent } from 'react';
import WithDataRecord from 'hoc/WithDataRecord';
import { AdminApi, AdminInvestmentList, AdminInvestmentsListOrderingEnum } from 'api';
import useGoTo from 'hooks/use-go-to';
import { ISSUER_ROUTES } from 'apps/issuer/pages/routes.config';
import StudioInvestmentsTable from 'src/apps/issuer/shared/studio-investments-table';

interface IssuerInvestmentsTableProps {
  forceDataLoad?: boolean;
  setForceDataLoad?: (val: boolean) => void;
  defaultLimit?: number;
  skipFilterUrlSync?: boolean;
  hasPermission: boolean;
  availableLimits?: number[];
  hidePaginationNavigation?: boolean;
  setFilterPopupHeight?: (height: number) => void;
  investorId?: string;
}

const IssuerInvestmentsTable: FunctionComponent<IssuerInvestmentsTableProps> = WithDataRecord<
  AdminApi,
  AdminInvestmentList
>(AdminApi)(
  ({
    data,
    ordering,
    onOrderBy,
    loading,
    hasPermission,
    paginationProps,
    hidePaginationNavigation,
    setFilterPopupHeight,
    investorId,
  }) => {
    const goTo = useGoTo(ISSUER_ROUTES.investmentDetails);

    return (
      <>
        <StudioInvestmentsTable
          loading={loading}
          onOrderBy={onOrderBy}
          ordering={ordering}
          goToDetails={(productId: string, investmentId: string) => goTo({ productId, investmentId })}
          paginationProps={paginationProps}
          hasPermission={hasPermission}
          hidePaginationNavigation={hidePaginationNavigation}
          investments={data}
          investorId={investorId}
          setFilterPopupHeight={setFilterPopupHeight}
        />
      </>
    );
  },
  (api, props, offset, limit, ordering) => {
    const { investorId, ...remainingProps } = props;

    return api.adminInvestmentsList({
      offset,
      limit,
      ordering: ordering as AdminInvestmentsListOrderingEnum,
      ...(props.investorId && { investorId: [props.investorId] }),
      ...remainingProps,
    });
  },
);

export default IssuerInvestmentsTable;
